/**
 * Communication event types for real-time webhook delivery-log updates.
 */
export enum CommunicationEventType {
  DELIVERY_RECORDED = 'communication:delivery-recorded',
  DELIVERY_EMIT = 'communication:delivery-emit',
  WEBHOOK_CREATED = 'communication:webhook-created',
  WEBHOOK_UPDATED = 'communication:webhook-updated',
  WEBHOOK_DELETED = 'communication:webhook-deleted',
  /**
   * Bulk child action progress. Exported here (not only in the service's
   * BULK_EVENTS) so the admin-ui can import the event name from @cluster/types.
   */
  BULK_ACTION_COMPLETED = 'bulk:action-completed',
}

/**
 * Payload for communication events.
 */
export interface CommunicationEvent {
  type?: CommunicationEventType;
  deliveryId?: string;
  webhookId?: string;
  ownerUserId?: string;
  outcome?: string;
  data: Record<string, unknown>;
  timestamp: string;
}

/**
 * Pub/sub channel for communication events.
 */
export const COMMUNICATION_EVENTS_CHANNEL = 'communication:events';

/**
 * WebSocket room for communication updates.
 */
export const COMMUNICATION_UPDATES_ROOM = 'communication:updates';